






































































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import { StepsKeys } from '@/plugins/podolib/services/analysis';
import { AnalysisType } from '@/components/analysis/steps/type/AnalysisStepType';

import ElementBgIcon from '@/components/elements/ElementBgIcon.vue';

@Component({
  components: { ElementBgIcon },
})
export default class AnalysisRemote extends Vue {
  /**
   * Helper for giving ability to use types and enums in DOM
   */
  tsdom = {
    Type: AnalysisType,
  };

  /**
   * Manifest entry of "type" step
   */
  get stepType() {
    return this.$pdc.analysis!.getManifestEntry(StepsKeys.Type);
  }

  /**
   * Manifest entry of "analysis" step
   */
  get stepAnalysis() {
    return this.$pdc.analysis!.getManifestEntry(StepsKeys.Analysis);
  }

  /**
   * Get 'patient' entity
   */
  get patient() {
    return this.$pdc.analysis!.entityPatient;
  }

  /**
   * Get 'command' entity
   */
  get command() {
    return this.$pdc.analysis!.entityCommand;
  }

  /**
   * Get current step key
   */
  get currentStepKey() {
    return this.$pdc.analysis!.currentStepKey;
  }

  /**
   * Get steps
   */
  get stepsWithLabel() {
    return this.$pdc.analysis!.stepsWithLabel;
  }

  /**
   * Get the index of the current step
   */
  get currentStepIndex() {
    return Object.values(this.stepsWithLabel.map((x) => x.key)).indexOf(this.currentStepKey);
  }

  /**
   * Get the current step with label format
   */
  get currentStepWithLabel() {
    return this.stepsWithLabel[this.currentStepIndex];
  }

  get analysisProgress() {
    if (!this.stepAnalysis.timer.current) {
      return null;
    } else {
      const diff = this.stepAnalysis.timer.endDate.diff(this.stepAnalysis.timer.startDate);
      const value = this.$moment()
        .add(this.$pdc.commons!.timeDrift, 'milliseconds')
        .diff(this.stepAnalysis.timer.startDate);

      const x1 = 0;
      const x2 = diff;
      const y1 = 0;
      const y2 = 100;

      return parseFloat((((value - x1) * (y2 - y1)) / (x2 - x1) + y1).toFixed(2));
    }
  }

  get analysisProgressFinished() {
    return this.analysisProgress && this.analysisProgress >= 100;
  }

  get progress() {
    return this.$pdc.analysis!.entityCommand?.data?.progress;
  }

  /**
   * Get step title
   */
  get title() {
    // Error
    if (this.stepAnalysis.error) {
      return this.$t('analysis.steps.analysis.title.error');
    }
    // Warn
    else if (this.stepAnalysis.warn) {
      return this.$t('analysis.steps.analysis.title.warn');
    }
    // Analysis 'isPending'
    else if (this.stepAnalysis.flags.analysis.isPending) {
      return this.$t('analysis.steps.analysis.title.is-pending');
    }
    // Analysis 'isStarted'
    else if (this.stepAnalysis.flags.analysis.isStarted) {
      return this.$t('analysis.steps.analysis.title.is-started');
    }
    // Analysis 'isStopped'
    else if (this.stepAnalysis.flags.analysis.isGettingData) {
      return this.$t('analysis.steps.analysis.title.is-getting-data');
    }
    // Compute 'isComputing'
    else if (this.stepAnalysis.flags.compute.isComputing) {
      return this.$t('analysis.steps.analysis.compute.computing');
    }
    // Compute 'isFailure'
    else if (this.stepAnalysis.flags.compute.isFailure) {
      return this.$t('analysis.steps.analysis.compute.failure');
    }
    // Compute 'isSuccess'
    else if (this.stepAnalysis.flags.compute.isSuccess) {
      return this.$t('analysis.steps.analysis.compute.success');
    }
    // Default
    else {
      return this.$t('analysis.background');
    }
  }

  get isError() {
    return this.stepAnalysis.error || this.stepAnalysis.warn;
  }

  /**
   * If is a patient page
   */
  get isPatientPage() {
    return this.$route.path.includes('/patient/');
  }

  /**
   * If is a running analysis
   */
  get isRunningAnalysis() {
    return this.$pdc.analysis?.defaultState.manifest.type.type === AnalysisType.Running;
  }
}
